import React, { useRef, useContext } from "react"
import ContentCard from "../../../../components/ContentCard"
import FavoriteFile from "../FavoriteFile"
import { Content, PreviewFrame, Col } from "./displays"
import { Link } from "react-router-dom"
import { useIsOutOfView } from "./hooks"
import FolderEdit from "./FolderEdit"
import AppContext from "../../../../shared/AppContext"
import "./style.scss"

export default function FolderPreview(props) {
  const FolderPreviewElem = useRef()

  const {
    folderId,
    folderName,
    style,
    viewAllLink,
    onViewAllClick,
    favoritesFiles,
    count,
    refetch,
    trackingLocation,
  } = props

  const { trackEvent } = useContext(AppContext)

  useIsOutOfView(FolderPreviewElem, (outOfView) => {
    if (FolderPreviewElem.current) {
      if (outOfView) {
        FolderPreviewElem.current.style.right = "0"
        FolderPreviewElem.current.style.left = "auto"
      } else {
        FolderPreviewElem.current.style.right = null
        FolderPreviewElem.current.style.left = null
      }
    }
  })

  return (
    <ContentCard
      className="folder-preview card-anim"
      style={style}
      ref={FolderPreviewElem}
    >
      <PreviewFrame>
        <Col>
          <Content name={folderName} count={count} />
          <FolderEdit
            folderId={folderId}
            folderName={folderName}
            refetch={refetch}
            trackingLocation={trackingLocation}
          />
        </Col>
        <Col style={{ flexGrow: 1 }}>
          {!favoritesFiles.length && (
            <div>No favorites added to this folder.</div>
          )}
          {!!favoritesFiles.length &&
            favoritesFiles.map((favorite, idx) => {
              return (
                <FavoriteFile
                  key={idx}
                  className="favorite-file"
                  hasMenu={true}
                  zIndex={0}
                  descriptionLenght={50}
                  favorite={favorite}
                  currentFolderId={folderId}
                  refetchQuery={refetch}
                  trackingLocation="Folder Preview"
                />
              )
            })}
          {!!favoritesFiles.length && (
            <Link
              className="view-all-link"
              to={viewAllLink}
              onClick={() => {
                onViewAllClick(folderId)
                trackEvent("Folder Preview: View all link click", {
                  text: "VIEW ALL",
                  folder: folderName,
                  to: viewAllLink,
                  location: trackingLocation,
                })
              }}
            >
              VIEW ALL
            </Link>
          )}
        </Col>
      </PreviewFrame>
    </ContentCard>
  )
}
